import { dataParaCompetencia, textoParaData } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { reais } from "@/lib/dinheiro";
import { rotulo } from "../estilos";

/** Lançamentos do mês da nota (entradas para nota emitida, saídas para recebida) para ligar a ela. */
export function LancamentosDaNota({ emitidaEm, tipo, marcados, onChange }: { emitidaEm: string; tipo: "ENTRADA" | "SAIDA"; marcados: string[]; onChange: (ids: string[]) => void }) {
  const competencia = emitidaEm ? dataParaCompetencia(textoParaData(emitidaEm)) : null;
  const lista = trpc.financeiro.lancamentos.listar.useQuery({ competencia: competencia ?? "2026-01" }, { enabled: !!competencia }).data ?? [];
  const opcoes = lista.filter((l) => l.tipo === tipo && !l.ehEstorno && (l.situacao !== "ESTORNADO" || marcados.includes(l.id)));
  const alternar = (id: string) => onChange(marcados.includes(id) ? marcados.filter((x) => x !== id) : [...marcados, id]);

  return (
    <div>
      <span className={rotulo}>Lançamentos desta nota (opcional)</span>
      {opcoes.length === 0 ? (
        <p className="rounded-md border border-dashed border-zinc-200 px-3 py-2 text-xs text-zinc-500 dark:border-border dark:text-muted-foreground">
          Nenhum lançamento de {tipo === "ENTRADA" ? "entrada" : "saída"} no mês da nota.
        </p>
      ) : (
        <ul className="max-h-40 divide-y divide-zinc-100 overflow-y-auto rounded-md border border-zinc-200 dark:divide-border/50 dark:border-border">
          {opcoes.map((l) => (
            <li key={l.id}>
              <label className="flex cursor-pointer items-center gap-2 px-3 py-1.5 text-xs hover:bg-zinc-50 dark:hover:bg-muted/40">
                <input type="checkbox" checked={marcados.includes(l.id)} onChange={() => alternar(l.id)} className="h-3.5 w-3.5 rounded border-zinc-300 text-brand-600" />
                <span className="min-w-0 flex-1 truncate text-zinc-800 dark:text-foreground">{l.descricao}</span>
                <span className="tabular-nums text-zinc-600 dark:text-muted-foreground">{reais(l.valorCents)}</span>
              </label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
